import React from 'react';
import { HelmetProvider as HeadProvider } from 'react-helmet-async';

var VeniaHeadProvider = function VeniaHeadProvider(props) {
  return React.createElement(HeadProvider, null, props.children);
};

export default VeniaHeadProvider;